import type { INewsListingItemDataClientDTO } from '../api/client/news/news.dto';
import {
  OG_SITE_NAME,
  OG_TYPE,
  SEO_DESCRIPTION,
  getAbsoluteUrl,
  getOgImageMeta,
} from './seo';
import { useOrigin } from './useOrigin';

const newsType = computed(() => useRoute().path.split('/', 2)[1]);

export const updateNewsItemsSeo = (
  items: INewsListingItemDataClientDTO[],
  title: string,
) => {
  const origin = useOrigin();
  const url = import.meta.client
    ? origin + window.location.pathname
    : origin + useRouter().currentRoute.value.fullPath;

  useHead({
    title: title,
    link: [{ rel: 'canonical', href: url }],
    meta: [
      { name: 'description', content: SEO_DESCRIPTION },
      { property: 'og:type', content: OG_TYPE },
      { property: 'og:url', content: url },
      { property: 'og:title', content: title },
      { property: 'og:description', content: SEO_DESCRIPTION },
      { property: 'og:site_name', content: OG_SITE_NAME },
      ...getOgImageMeta(origin),
    ],
    script: [
      {
        type: 'application/ld+json',
        key: 'ld-json-article',
        innerHTML: {
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: title,
          description: SEO_DESCRIPTION,
          mainEntity: (items ?? []).map((item) => ({
            '@type': 'Article',
            headline: item.title,
            datePublished: item.publication_date,
            url: `${origin}/${newsType.value}/${item.id}`,
            image: getAbsoluteUrl(origin, item.image?.photo.file_url) ?? '',
            description: item?.subject,
          })),
        },
      },
    ],
  });
};
